import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { CommonUtilitiesService } from '../common-utilities.service';

@Component({
  selector: 'app-payment-view-urlerror-recurrent',
  templateUrl: './payment-view-urlerror-recurrent.component.html',
  styleUrls: ['./payment-view-urlerror-recurrent.component.scss']
})
export class PaymentViewUrlerrorRecurrentComponent implements OnInit {

  errorMsg = "";

  constructor(public LANG: CommonUtilitiesService, private route: ActivatedRoute) { }

  ngOnInit() {

    let _self = this;
    this.route.params.subscribe(params => this.setErrorParams(params));

    document.getElementById('error-msg').scrollIntoView();

  }

  setErrorParams(params) {
    this.errorMsg = params.errorMsg;
  }

}
